<!--资环行动-详情页-->
<template class="carbon">
  <div style="font-family: Alibaba">
    <!--CP端-->
    <div class="PC_box">
      <!--插入头部-->
      <div>
        <keep-alive>
          <component class="act" :is='components.tail'></component>
        </keep-alive>
      </div>

      <div class="box-width newsDetail">
        <h4>{{ newsDetail.title }}</h4>
        <span class="time">{{ newsDetail.releaseTime }}</span>
        <span class="name" style="margin-left: 10px;">{{ newsDetail.author }}</span>
      </div>
      <!--内容-->
      <div v-html="replaceContent(newsDetail.content)" class="htmlImgSize box-width"></div>

      <!--插入尾部-->
      <div>
        <keep-alive>
          <component  :is='components.tail1'></component>
        </keep-alive>
      </div>
    </div>

    <!--手机端-->
    <div class="mobile_box product">
      <!--插入头部-->
      <div>
        <keep-alive>
          <component :is='components.tail'></component>
        </keep-alive>
      </div>

      <div class='paddingS'>
        <!--占位div-->
        <div style='height: 72px'></div>

        <div class="box-width mobileDetail">
          <h4 >{{ newsDetail.title }}</h4>
          <span class="time">{{ newsDetail.releaseTime }}</span>
          <span class="name" style="margin-left: 10px;">{{ newsDetail.author }}</span>
        </div>
        <!--内容-->
        <div v-html="replaceContent(newsDetail.content)" class="htmlImgSize"></div>

        <!--插入尾部-->
        <div>
          <keep-alive>
            <component  :is='components.tail1'></component>
          </keep-alive>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import header from '../components/header.vue'
import footer from '../components/footer.vue'
import { findOneNews } from "@/api/zh"

export default {
  data () {
    return {
      components: {
        tail: header,
        tail1: footer
      },
      newsDetail: {},
      newsId: null
    }
  },
  created () {
    this.newsId = this.$route.query.newsId
  },
  mounted () {
    this.getNewsDetail()
  },
  methods: {
    async getNewsDetail () {
      const res = await findOneNews(this.newsId)
      if (res.code === 200) {
        this.newsDetail = res.data
      }
    },
    replaceContent (content) {
      return content.replace(/http:\/\/8\.155\.44\.137:9000\/zihuan\//g, 'https://gdlsfw.com/zihuan/')
    }
  }
}
</script>

<style scoped>
::v-deep .htmlImgSize img {
  max-width: 100%;
  height: auto;
  background: transparent;
}
</style>
